import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetScheduleWeekArgs, ScheduleWeek } from "../schemas/ScheduleWeek";

export const queryKeyPrefix = "getPatientTreatmentScheduleWeek";
type QueryKey = [typeof queryKeyPrefix, GetScheduleWeekArgs];
const getPatientTreatmentScheduleWeekQueryKey = (args: GetScheduleWeekArgs): QueryKey => [queryKeyPrefix, args];

export const useGetPatientTreatmentScheduleWeek = (
  args: GetScheduleWeekArgs,
  options?: UseQueryOptions<ScheduleWeek, Error, ScheduleWeek, QueryKey>
) => {
  const client = useApiClient();

  return useQuery(
    getPatientTreatmentScheduleWeekQueryKey(args),
    () => client.getPatientTreatmentScheduleWeek(args),
    options
  );
};
